import { render, staticRenderFns } from "./DropDownIcon.vue?vue&type=template&id=0a297d07&scoped=true&"
import script from "./DropDownIcon.vue?vue&type=script&lang=js&"
export * from "./DropDownIcon.vue?vue&type=script&lang=js&"
import style0 from "./DropDownIcon.vue?vue&type=style&index=0&id=0a297d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a297d07",
  null
  
)

export default component.exports